import { projectTreso, projectResultat } from "@/components/memo/TresoTable";
import { empruntsByMonth } from "@/lib/emprunts";

const nz = (v) => Number(String(v ?? "").replace(/[^\d.-]/g, "")) || 0;

// SUPER-LOT 106 — KPIs synthétiques d'un scénario (pour le comparateur). Réutilise les moteurs de projection.
export function computeScenarioKpis(prev) {
    const params = prev?.parametres_scenario || {};
    const data = prev?.data_json || {};
    const start = params.date_rj || null;
    const horizon = Number(params.duree_mois) || 6;
    const sal = data.salaires;
    const treso0 = nz(params.tresorerie_initiale);
    const tresoRows = projectTreso(data.revenus || [], data.charges_exploitation || [], data.charges || [], treso0, start, sal, horizon, data.charges_fixes_date_prochain_paiement, null, data.emprunts || []);
    const tresoFin = tresoRows.length ? tresoRows[tresoRows.length - 1].cumul : 0;
    const resRows = projectResultat(data.revenus || [], data.charges_exploitation || [], data.charges || [], sal, start, horizon);
    const empMois = empruntsByMonth(data.emprunts || [], resRows.map((r) => r.key));
    const cr = data.compte_resultat || {};
    let ebe = 0, amort = 0, ech = 0;
    for (const r of resRows) {
        ebe += nz(r.ca) - nz(r.achats) - nz(r.loyers) - nz(r.autres_charges_externes) - nz(r.impots_taxes) - nz(r.autres_charges) - nz(r.salaires) - nz(r.charges_sociales);
        amort += nz((cr.amortissements || {})[r.key]);
        ech += empMois[r.key]?.echeance || 0;
    }
    const re = ebe - amort; // Résultat d'exploitation = EBE − amortissements
    let dscr = null, statut = "none";
    if (ech > 0 && ebe > 0) { dscr = ebe / ech; statut = dscr > 1.2 ? "sain" : (dscr >= 1.0 ? "tendu" : "defaut"); }
    else if (ech > 0 && ebe <= 0) { statut = "na"; }
    return { re, tresoFin, dscr, statut, mois: resRows.length };
}
